import React from "react";
import Layout from "../components/layout";
import BlogRoll from "../components/BlogRoll";
import Head from "../components/head";


export default () => (
    <Layout>
        <Head title="blogs" />
        <h1>Blog Posts</h1>
          <section>
            <div className="content">
              <BlogRoll categorie={"blog"} />
            </div>
          </section>
    </Layout>
)



